/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smug_Cute_Scallop_BuyInputs */

const fr_smug_cute_scallop_buy = /** @type {(inputs: Smug_Cute_Scallop_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privée`)
};

/**

* @param {Smug_Cute_Scallop_BuyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const smug_cute_scallop_buy = /** @type {((inputs?: Smug_Cute_Scallop_BuyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smug_Cute_Scallop_BuyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_smug_cute_scallop_buy(inputs)
});